module.exports = __webpack_public_path__ + "static/media/cover.2d46e7c4.png";